import { Api } from '../../services/api';

import { useState } from 'react';

// eslint-disable-next-line
export const TokenModal = () => {
  //eslint-disable-next-line
  const [motorista, setMotorista] = useState('');
  const [descricao, setDescricao] = useState('');
  const [transportadora, setTransportadora] = useState('');

  const [reqId, setReqId] = useState(2);
  const [clickBtn, setClickBtn] = useState(false);

  const [isCreated, setIsCreated] = useState(false);

  const [inputError, setInputError] = useState({
    motorista: false,
    descricao: false,
    transportadora: false,
  });

  //eslint-disable-next-line
  const [erro, setErro] = useState(null);

  const createToken = async () => {
    const resetInput = {
      motorista: false,
      descricao: false,
      transportadora: false,
    };

    setInputError({
      ...resetInput,
      motorista: false,
      descricao: false,
      transportadora: false,
    });

    console.log(inputError);

    setErro(0);
    try {
      if (!(motorista.length > 0) || !(descricao.length > 0) || !(transportadora.length > 0)) {
        setErro('Favor preencher todos os campos para seguir!');
        let objInputError = {
          motorista: false,
          descricao: false,
          transportadora: false,
        };

        if (!(motorista.length > 0)) {
          objInputError = {
            ...objInputError,
            motorista: true,
          };
        }

        if (!(descricao.length > 0)) {
          objInputError = {
            ...objInputError,
            descricao: true,
          };
        }

        if (!(transportadora.length > 0)) {
          objInputError = {
            ...objInputError,
            transportadora: true,
          };
        }

        setInputError({
          ...objInputError,
        });

        return;
      }

      const token = await Api.post('/token/create', {
        motorista,
        descricao,
        transportadora,
      });

      setReqId(token.data.id);

      setMotorista('');
      setDescricao('');
      setTransportadora('');
      setIsCreated(true);
    } catch (e) {
      if (e.response.status == 404) {
        setErro('Tivemos um problemas ao criar o token, contate a TI');
        return;
      }
      setErro('Não foi possivel criar o token, tente novamente');
    }
  };

  const handleClick = () => {
    setClickBtn(true);
    createToken();
  };

  return (
    <div>
      <div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className={`form-control ${inputError.motorista ? 'is-invalid' : ''}`}
            id="floatingInput"
            autoComplete="false"
            onChange={(e) => setMotorista(e.target.value)}
            value={motorista}
            disabled={isCreated}
          />
          <label htmlFor="floatingInput">Nome do Motorista</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className={`form-control ${inputError.descricao ? 'is-invalid' : ''}`}
            id="floatingPassword"
            autoComplete="false"
            onChange={(e) => setDescricao(e.target.value)}
            value={descricao}
            disabled={isCreated}
          />
          <label htmlFor="floatingPassword">Descrição</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className={`form-control ${inputError.transportadora ? 'is-invalid' : ''}`}
            id="floatingPassword"
            autoComplete="false"
            onChange={(e) => setTransportadora(e.target.value)}
            value={transportadora}
            disabled={isCreated}
            aria-describedby="corrija-error"
          />
          <label htmlFor="floatingPassword">Código transportadora</label>
        </div>
        <div className="row">
          {isCreated ? (
            <div className="alert alert-success w-100" style={{ textAlign: 'center' }} role="alert">
              Token de n° <b>{reqId}</b> criado com sucesso!
            </div>
          ) : (
            <>
              <div className="col" style={{ textAlign: 'center', margin: 'auto' }}>
                {erro && clickBtn && <span>{erro != 0 ? erro : ''}</span>}
              </div>
              <div className="col">
                <button className="btn btn-success" style={{ float: 'right' }} onClick={handleClick}>
                  Gerar Token
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
